/**
 * What a table's shape is called in this plan.
 *
 * One shape, two names: the table whose chairs all face the room is the
 * couple's sweetheart table at a wedding and a head table anywhere else. The
 * shape id stays `sweetheart` everywhere it is stored; only the word changes.
 */

import type { EventKind, TableShape } from '../types'
import type { Catalogue } from './locales/en'

export function shapeName(t: Catalogue, shape: TableShape, kind: EventKind): string {
  return shape === 'sweetheart' && kind !== 'wedding' ? t.shape.head : t.shape[shape]
}

/** The add-a-table list's wording, which names a few shapes differently. */
export function railShape(
  t: Catalogue,
  shape: TableShape,
  kind: EventKind,
): { title: string; blurb: string | null } {
  switch (shape) {
    case 'round':
      return { title: t.rail.roundTable, blurb: null }
    case 'square':
      return { title: t.rail.squareTable, blurb: null }
    case 'rectangle':
      return { title: t.rail.rectangleTable, blurb: null }
    case 'sweetheart':
      return kind === 'wedding'
        ? { title: t.rail.sweetheartTable, blurb: t.rail.sweetheartBlurb }
        : { title: t.rail.headTable, blurb: t.rail.headBlurb }
  }
}
